const track = document.querySelector(".carousel-track");
const cards = Array.from(track.children);
const prevButton = document.getElementById("prev");
const nextButton = document.getElementById("next");

let currentIndex = 0;
let cardsToShow = window.innerWidth <= 600 ? 1 : 3;

const updateCarousel = () => {
  const cardWidth = track.clientWidth / cardsToShow;
  track.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
};

const resizeHandler = () => {
  cardsToShow = window.innerWidth <= 600 ? 1 : 3;
  track.style.transition = "none"; // Prevent animation during resize
  updateCarousel();
  setTimeout(() => (track.style.transition = "transform 0.5s ease-in-out"));
};

prevButton.addEventListener("click", () => {
  if (currentIndex > 0) {
    currentIndex -= 1;
    updateCarousel();
  }
});

nextButton.addEventListener("click", () => {
  if (currentIndex < cards.length - cardsToShow) {
    currentIndex += 1;
    updateCarousel();
  }
});

window.addEventListener("resize", resizeHandler);
updateCarousel();
